import { Modal, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons, Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface ConfirmDeleteWithoutInventoryModalProps {
  locationName: string;
  onConfirm: () => void;
  onClose: () => void;
}

function ConfirmDeleteWithoutInventoryModal({
  locationName,
  onConfirm,
  onClose,
}: Readonly<ConfirmDeleteWithoutInventoryModalProps>) {
  const t = useTranslationShipping();

  return (
    <>
      <Modal.Header
        title={t('locations.deleteSteps.confirmDeleteWithoutInventory.title', {
          name: locationName,
        })}
      />
      <Modal.Body padding="none">
        <Text>
          {t('locations.deleteSteps.confirmDeleteWithoutInventory.description')}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Stack spacing="base" justify="flex-end">
          <CancelAndConfirmButtons
            appearance="danger"
            onCancel={onClose}
            onConfirm={onConfirm}
            confirmText={t(
              'locations.deleteSteps.confirmDeleteWithoutInventory.confirm',
            )}
          />
        </Stack>
      </Modal.Footer>
    </>
  );
}

export default ConfirmDeleteWithoutInventoryModal;
